module.exports = __webpack_public_path__ + "img/anli-banner1.31c22688.jpg";